import React from 'react';
import { whyFitFrameData } from '../data/mock';
import { Card, CardContent } from './ui/card';
import { MapPin, Users, TrendingUp, Award } from 'lucide-react';

const iconMap = {
  0: MapPin,
  1: Users,
  2: TrendingUp,
  3: Award
};

const WhyFitFrame = () => {
  return (
    <section className="bg-[#0d0d0d] py-20 md:py-32">
      <div className="max-w-[87.5rem] mx-auto px-5 md:px-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="font-['Bebas_Neue'] text-white text-5xl md:text-7xl tracking-wide">
            BUILT FOR GYM CULTURE
          </h2>
        </div>

        {/* Reason Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {whyFitFrameData.map((reason, index) => {
            const Icon = iconMap[index];
            return (
              <Card 
                key={reason.id}
                className="bg-[#302f2c] border-[#3f4816] border-opacity-50 hover:bg-[#3f4816] transition-all duration-300"
              >
                <CardContent className="p-8 md:p-10">
                  <div className="mb-6">
                    <Icon className="w-12 h-12 text-[#e8ff47]" strokeWidth={1.5} />
                  </div>
                  <h3 className="font-['Bebas_Neue'] text-[#e8ff47] text-3xl md:text-4xl mb-4">
                    {reason.title}
                  </h3>
                  <p className="font-['DM_Sans'] text-[#dfddd6] text-base md:text-lg leading-relaxed">
                    {reason.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyFitFrame;
